export function StarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_9643_18798"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="white" />
      </mask>
      <g mask="url(#mask0_9643_18798)">
        <path
          d="M10.3465 2.73257C10.2101 2.42248 9.78987 2.42248 9.65348 2.73257L7.72084 7.12663C7.66525 7.25301 7.55104 7.34003 7.41925 7.35642L2.83714 7.92616C2.51377 7.96637 2.3839 8.38553 2.62298 8.61739L6.01065 11.9028C6.10809 11.9973 6.15171 12.1381 6.12585 12.2746L5.22659 17.0208C5.16313 17.3557 5.50312 17.6148 5.78727 17.448L9.81361 15.0844C9.92942 15.0165 10.0706 15.0165 10.1864 15.0844L14.2127 17.448C14.4969 17.6148 14.8369 17.3557 14.7734 17.0208L13.8742 12.2746C13.8483 12.1381 13.8919 11.9973 13.9894 11.9028L17.377 8.61739C17.6161 8.38553 17.4862 7.96637 17.1629 7.92616L12.5808 7.35642C12.449 7.34003 12.3347 7.25301 12.2792 7.12663L10.3465 2.73257Z"
          fill="#0E3739"
        />
      </g>
    </svg>
  );
}

export function ReviewCard({
  card,
  cardClass,
  itemClass = '',
  quoteClass = 'h5',
  baseClass = 'flex w-70 flex-col items-start gap-5 px-8 py-7 sm:w-full sm:p-10',
  alignClass = 'items-center justify-center sm:items-start sm:justify-start',
  textAlignClass = 'text-center sm:text-left',
  dateRowClass = 'flex-col items-center gap-1 sm:flex-row sm:items-end sm:justify-between sm:gap-0',
  dateTextClass = 'text-dark-grey-text',
  productNameClass = ''
}) {
  const isMobileReview = itemClass.includes('max-w-[420px]');
  const mobileBaseClass = isMobileReview
    ? 'flex w-70 flex-col items-start gap-5 p-[28px_32px]'
    : baseClass;
  const {
    star_rating,
    review_quote,
    reviewer_name,
    product_name,
    review_date
  } = card ?? {};

  return (
    <div
      className={`text-parlor-green ${mobileBaseClass} ${itemClass} ${cardClass}`}
    >
      <div className={`flex w-full flex-col gap-5 self-stretch ${alignClass}`}>
        {star_rating > 0 && (
          <div
            className={`flex w-full self-stretch ${alignClass}`}
            role="img"
            aria-label={`${star_rating} star rating`}
          >
            {Array.from({ length: star_rating }).map((_, i) => (
              <StarIcon key={i} />
            ))}
          </div>
        )}
        {review_quote && (
          <p className={`${quoteClass} w-full ${textAlignClass}`}>
            {review_quote}
          </p>
        )}
        {(reviewer_name || product_name || review_date) && (
          <div className="flex w-full flex-col">
            {reviewer_name && (
              <div className={`flex w-full self-stretch ${alignClass}`}>
                <span className="body-r">{reviewer_name}</span>
              </div>
            )}
            {(product_name || review_date) && (
              <div
                className={`${dateTextClass} flex w-full self-stretch ${dateRowClass}`}
              >
                {product_name && (
                  <span className={`body-s ${productNameClass}`}>
                    {product_name}
                  </span>
                )}
                {review_date && <span className="body-s">{review_date}</span>}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
